/**
 * @module components/TabsBackground
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Request summary table
 */

import { useLanguageState } from '../contexts/language-state-provider';

type Props = {
  variables: HazardParameters
}


/**
 * React component
 * ===============
 */
const TabsBackground = ({
  variables
}: Props) => {
  const [lang] = useLanguageState();

  if (lang.abbr === 'fr') {
    if (variables.code === 'nbc2020') {
      return (
        <>
          <p>Consultez la sous-section 4.1.8 du CNB 2020 pour les exigences de conception sismique et le commentaire intitulé Calcul fondé sur les effets dus aux séismes du <em>Commentaires sur le calcul des structures (Guide de l'utilisateur - CNB 2020 : Partie 4 de la division B)</em> pour des renseignements généraux et conseils.</p>
          <p>Le modèle d'aléa sismique utilisé pour le CNB 2020 est décrit dans le dossier public 8924 de la Commission géologique du Canada (CGC) au <a href="https://doi.org/10.4095/331387">https://doi.org/10.4095/331387</a>. Pour des renseignements généraux sur l'aléa sismique, y compris les cartes d'aléa sismique, consultez la page <a href="/hazard-alea/index-fr.php">Aléa sismique</a>.</p>
          <p>Cette application fournit des valeurs interpolées d'aléas sismiques. L'interpolation est effectuée pour une cible de probabilité de dépassement, une désignation d'emplacement X<sub>V</sub> (V<sub>s30</sub>) et un emplacement. L'ensemble de données pré-calculées utilisées pour l’interpolation est disponible dans le dossier public 8950 de la CGC <a href="https://doi.org/10.4095/331497">https://doi.org/10.4095/331497</a>.</p>
        </>
      );
    } else {
      return (
        <>
          <p>Consultez la sous-section 4.1.8 du CNB 2025 pour les exigences de conception sismique et le commentaire intitulé Calcul fondé sur les effets dus aux séismes du <em>Commentaires sur le calcul des structures (Guide de l'utilisateur - CNB 2025 : Partie 4 de la division B)</em> pour des renseignements généraux et conseils.</p>
          <p>Pour des renseignements généraux sur l'aléa sismique, y compris les cartes d'aléa sismique, consultez la page <a href="/hazard-alea/index-fr.php">Aléa sismique</a>.</p>
          <p>Cette application fournit des valeurs interpolées d'aléas sismiques. L'interpolation est effectuée pour une cible de probabilité de dépassement, une désignation d'emplacement X<sub>V</sub> (V<sub>s30</sub>) et un emplacement.</p>
        </>
      );
    }
  }

  if (variables.code === 'nbc2020') {
    return (
      <>
        <p>Refer to Subsection 4.1.8 of the NBC 2020 for seismic design requirements and to the Commentary entitled Design for Seismic Effects in the <em>Structural Commentaries (User's Guide - NBC 2020: Part 4 of Division B</em> for background information and guidance.</p>
        <p>The seismic hazard model used for NBC 2020 is described in Geological Survey of Canada (GSC) Open File 8924 (<a href="https://doi.org/10.4095/331387">https://doi.org/10.4095/331387</a>). For general information on seismic hazard, including seismic hazard maps, go to <a href="/hazard-alea/index-en.php">Earthquake Hazard</a>.</p>
        <p>This application returns interpolated seismic hazard values. Interpolation is performed for the target probability of exceedance, site designation X<sub>V</sub> (V<sub>s30</sub>), and location. The pre-calculated dataset from which the interpolation is performed is available in GSC Open File 8950 (<a href="https://doi.org/10.4095/331497">https://doi.org/10.4095/331497</a>).</p>
      </>
    );
  } else {
    return (
      <>
        <p>Refer to Subsection 4.1.8 of the NBC 2025 for seismic design requirements and to the Commentary entitled Design for Seismic Effects in the <em>Structural Commentaries (User's Guide - NBC 2025: Part 4 of Division B)</em> for background information and guidance.</p>
        <p>For general information on seismic hazard, including seismic hazard maps, go to <a href="/hazard-alea/index-en.php">Earthquake Hazard</a>.</p>
        <p>This application returns interpolated seismic hazard values. Interpolation is performed for the target probability of exceedance, site designation X<sub>V</sub> (V<sub>s30</sub>), and location.</p>
      </>
    );
  }
};

export default TabsBackground;